
    import {Options, Vue} from 'vue-property-decorator';

    @Options({})
    export default class BriefLoader extends Vue {}
